import { Group, Stack, Text } from '@mantine/core';
import { DetailCard, type WaRendererProps } from './primitives';

/** Catalog order summary — line items capped at five. */
export function OrderCard({ view }: WaRendererProps) {
  const items = view.order;
  if (!items) return null;
  return (
    <DetailCard title={`🛒 Order · ${items.length} item${items.length === 1 ? '' : 's'}`}>
      <Stack gap={2}>
        {items.slice(0, 5).map((it, i) => (
          <Group key={i} justify="space-between" gap="xs" wrap="nowrap">
            <Text size="xs" lineClamp={1}>
              {it.quantity}× {it.id || 'Item'}
            </Text>
            {it.price > 0 && (
              <Text size="xs" c="dimmed">
                {it.price} {it.currency}
              </Text>
            )}
          </Group>
        ))}
        {items.length > 5 && (
          <Text size="xs" c="dimmed">
            +{items.length - 5} more
          </Text>
        )}
      </Stack>
    </DetailCard>
  );
}
